import { css } from "../helpers/webComponents";
import { GameEventService } from "../services/GameEventService";
import { Page } from "../enums/Page";

// De stijl van de knop
const styles: string = css`
    :host {
        display: inline-block;
    }

    #leaderboardButton {
        padding: 10px 20px;
        background-color: #52478b;
        color: white;
        font-size: 16px;
        border: none;
        border-radius: 5px;
        cursor: pointer;
    }

    #leaderboardButton:hover {
        background-color: #403272;
    }
`;

export class LeaderboardButtonComponent extends HTMLElement {
    private _gameEventService: GameEventService = new GameEventService();

    public constructor() {
        super();
        this.attachShadow({ mode: "open" });
    }

    public connectedCallback(): void {
        this.render();
        this.addEventListeners();
    }

    private render(): void {
        if (!this.shadowRoot) {
            return;
        }
        this.shadowRoot.innerHTML = `
            <style>${styles}</style>
            <button id="leaderboardButton">Bekijk Leaderboard</button>
        `;
    }

    private addEventListeners(): void {
        if (!this.shadowRoot) {
            return;
        }
        const leaderboardButton: HTMLElement = this.shadowRoot.querySelector("#leaderboardButton") as HTMLElement;
        leaderboardButton.addEventListener("click", () => this.showLeaderboard());
    }

    private showLeaderboard(): void {
        this._gameEventService.switchPage(Page.Leaderboard);
    }
}
